export default __webpack_public_path__ + "static/media/avatar_14.e87f3a8f.svg";